import styled from 'styled-components';

import {
  flexCentreAlignCss,
  flexColumnCss,
} from 'approot/shared/styles/flex.style';
import { rem } from 'approot/shared/style';
import { grey10, grey4 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { spacing12, spacing16 } from 'approot/shared/styles/spacing.style';
import { baseDragItemBaseColour } from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag.style';
import { baseDropItemCss } from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drop.style';
import {
  DROP_ITEM_SIZE,
  MIN_LABEL_WIDTH,
} from '../settings/interactive-response.constants';
import { font20 } from 'approot/shared/styles/typography.style';

type InteractiveDropItemProps = {
  $labelLength?: number | null;
  $labelBorder?: boolean | null;
  $baseColour?: string;
};
export const InteractiveSequenceDropItem = styled.div<InteractiveDropItemProps>`
  ${flexColumnCss}
  ${baseDragItemBaseColour}

  max-width: ${({ $labelLength }) => rem($labelLength || MIN_LABEL_WIDTH)};
  width: 100%;

  ${({ $labelBorder }) =>
    $labelBorder &&
    `
      border: 1px solid ${grey4};
      border-radius: ${rem(borderRadius8)};
      padding: ${rem(spacing12)};
  `}

`;

export const InteractiveSequenceDropLabel = styled.div`
  ${font20}
  color: ${grey10};
  margin-top: ${rem(spacing16)};
  text-align: center;
`;

type InteractiveDropItemTargetProps = {
  $isOver?: boolean;
  $canDrop?: boolean;
  $hasDropped?: boolean;
  $isCorrect?: boolean;
  $width?: number;
  $height?: number;
};

export const InteractiveSequenceDropItemTarget = styled.div<
  InteractiveDropItemTargetProps
>`
  ${flexCentreAlignCss}
  ${baseDropItemCss}

  width: ${({ $width }) => rem($width || DROP_ITEM_SIZE)};
  height: ${({ $height }) => rem($height || DROP_ITEM_SIZE)};
`;

export const InteractiveSequenceDropItemZone = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 2;
`;
